import { render, staticRenderFns } from "./psp-type-form.vue?vue&type=template&id=3f2a2fab"
import script from "./psp-type-form.vue?vue&type=script&lang=js"
export * from "./psp-type-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports